module.exports = __webpack_public_path__ + "img/al2.35cf9400.png";